import { useState, useEffect } from 'react';
import { Box, Button, Typography, Grid } from '@mui/material';
import useForm from '../../../hooks/useForm';
import StyledModal from '../StyledModal';
import GreenBorderBox from '../../common/GreenBorderBox';
import { Button as StyledButton, TextField } from '../../common';
import colors from '../../../assets/colors';
import EditInfoParametersPlants from './EditInfoParametersPlants';
import { incomeParameters } from '../../../utils/api';
import MassEditPlantParametersModal from './MassEditPlantParametersModal';

export default function EditParametersPlantsModal(props) {
  const [editInfoModalOpen, setEditInfoModalOpen] = useState(false);
  const [massEditOpen, setMassEditOpen] = useState(false);
  const [currentlySelected, setCurrentlySelected] = useState(0);
  const { handleChange, setFieldValues, values } = useForm({
    value1: 0,
    value2: 0,
    value3: 0,
  });
  const handleClose = () => props.setOpen(false);
  const handleConfirm = () => setEditInfoModalOpen(true);

  const setData = () => {
    setFieldValues({
      value1: props.selectionData[currentlySelected]?.indexList[0].incomeValue,
      value2: props.selectionData[currentlySelected]?.indexList[1].incomeValue,
      value3: props.selectionData[currentlySelected]?.indexList[2].incomeValue,
    });
  };

  useEffect(() => {
    setData([]);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData([]);
    //eslint-disable-next-line
  }, [currentlySelected]);

  const increaseSelected = () => {
    if (currentlySelected + 1 < props.selected.length)
      setCurrentlySelected((prev) => prev + 1);
  };

  const decreaseSelected = () => {
    if (currentlySelected - 1 >= 0) setCurrentlySelected((prev) => prev - 1);
  };

  const editParameter = () => {
    const body = {
      id: props.selectionData[currentlySelected].id,
      indexList: [
        {
          incomeValue: values.value1,
          maxArea: props.selectionData[currentlySelected].indexList[0].maxArea,
          minArea: props.selectionData[currentlySelected].indexList[0].minArea,
        },
        {
          incomeValue: values.value2,
          maxArea: props.selectionData[currentlySelected].indexList[1].maxArea,
          minArea: props.selectionData[currentlySelected].indexList[1].minArea,
        },
        {
          incomeValue: values.value3,
          maxArea: props.selectionData[currentlySelected].indexList[2].maxArea,
          minArea: props.selectionData[currentlySelected].indexList[2].minArea,
        },
      ],
    };
    if (props.local) {
      props.setData(
        props.data.map((el) =>
          el.id === body.id
            ? { ...el, indexList: body.indexList, edited: true }
            : el
        )
      );
    } else {
      incomeParameters
        .editCropParameter(props.selectionData[currentlySelected].id, body)
        .then((res) => {
          props.updateParameters();
        })
        .catch((err) => {});
    }
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Box>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
              Edytuj wskaźniki
            </Typography>
            {props.selected?.length > 1 && (
              <Button variant="contained" sx={{ mx: 2 }}>
                {currentlySelected + 1 + ' z ' + props.selected?.length}
              </Button>
            )}
          </Grid>
          <GreenBorderBox>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              columnSpacing={10}
            >
              <Grid container item xs={4} direction="column" rowSpacing={1}>
                <Grid item>
                  <Typography sx={{ color: colors.agroweGreen }}>
                    Nazwa uprawy
                  </Typography>
                </Grid>
                <Grid item>
                  {props.selectionData[currentlySelected]?.cropName}
                </Grid>
              </Grid>
              <Grid container item xs={4} direction="column" rowSpacing={1}>
                <Grid item>
                  <Typography sx={{ color: colors.agroweGreen }}>
                    Zakresy
                  </Typography>
                </Grid>
                <Grid item>
                  {`${props.selectionData[currentlySelected]?.indexList[0]?.minArea}
                  -
                  ${props.selectionData[currentlySelected]?.indexList[0]?.maxArea}
                  ha`}
                </Grid>
                <Grid
                  item
                >{`${props.selectionData[currentlySelected]?.indexList[1]?.minArea}
                  -
                  ${props.selectionData[currentlySelected]?.indexList[1]?.maxArea}
                  ha`}</Grid>
                <Grid item>{`${
                  props.selectionData[currentlySelected]?.indexList[2]?.minArea
                }${
                  props.selectionData[currentlySelected]?.indexList[2]
                    ?.maxArea > 100
                    ? '+'
                    : ' ' +
                      props.selectionData[currentlySelected]?.indexList[2]
                        ?.maxArea
                } ha`}</Grid>
              </Grid>
              <Grid container item xs={4} direction="column" rowSpacing={1}>
                <Grid item>
                  <Typography sx={{ color: colors.agroweGreen }}>
                    Wartość wskaźnika (PLN)
                  </Typography>
                </Grid>
                {
                  props.selectionData[currentlySelected]?.indexList[0]
                    ?.incomeValue
                }
                <Grid item>
                  {
                    props.selectionData[currentlySelected]?.indexList[1]
                      ?.incomeValue
                  }
                </Grid>
                <Grid item>
                  {
                    props.selectionData[currentlySelected]?.indexList[2]
                      ?.incomeValue
                  }
                </Grid>
              </Grid>
            </Grid>
          </GreenBorderBox>
          <Grid
            container
            direction="row"
            justifyContent="left"
            columnSpacing={8}
            sx={{ mt: 3, p: 3 }}
          >
            <Grid container item xs={4} direction="column">
              <TextField
                label="Aktualny wskaźnik"
                modalRight
                variant="standard"
                value={props.selectionData[currentlySelected]?.cropName}
                disabled
              />
            </Grid>
            <Grid
              container
              item
              xs={4}
              direction="column"
              sx={{ textAlign: 'left' }}
            >
              <TextField
                label="Wskaźnik w przedziale"
                modalRight
                sx={{ mb: 4, textAlign: 'left' }}
                variant="standard"
                value={`${props.selectionData[currentlySelected]?.indexList[0]?.minArea} - ${props.selectionData[currentlySelected]?.indexList[0]?.maxArea} ha`}
                disabled
              />
              <TextField
                label="Wskaźnik w przedziale"
                modalRight
                sx={{ mb: 4, textAlign: 'left' }}
                variant="standard"
                value={`${props.selectionData[currentlySelected]?.indexList[1]?.minArea} - ${props.selectionData[currentlySelected]?.indexList[1]?.maxArea} ha`}
                disabled
              />
              <TextField
                label="Wskaźnik w przedziale"
                modalRight
                variant="standard"
                sx={{ textAlign: 'left' }}
                value={`${
                  props.selectionData[currentlySelected]?.indexList[2]?.minArea
                }${
                  props.selectionData[currentlySelected]?.indexList[2]
                    ?.maxArea > 100
                    ? '+'
                    : ' ' +
                      props.selectionData[currentlySelected]?.indexList[2]
                        ?.maxArea
                } ha`}
                disabled
              />
            </Grid>
            <Grid container item xs={4} direction="column">
              <TextField
                modalRight
                label="Wartość PLN"
                variant="outlined"
                value={values.value1}
                onChange={handleChange('value1')}
              />
              <TextField
                modalRight
                label="Wartość PLN"
                variant="outlined"
                value={values.value2}
                onChange={handleChange('value2')}
              />
              <TextField
                modalRight
                label="Wartość PLN"
                variant="outlined"
                value={values.value3}
                onChange={handleChange('value3')}
              />
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="space-evenly"
            sx={{ mt: 2 }}
            columnSpacing={1}
          >
            {props.selected?.length > 1 && (
              <>
                <Grid item container xs={4}>
                  <Grid item>
                    <Button variant="outlined" onClick={decreaseSelected}>
                      POPRZEDNI
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained">
                      {currentlySelected + 1 + ' z ' + props.selected?.length}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" onClick={increaseSelected}>
                      NASTĘPNY
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <StyledButton
                    variant="contained"
                    sx={{ height: 40 }}
                    onClick={() => setMassEditOpen(true)}
                  >
                    EDYTUJ MASOWO WPISY
                  </StyledButton>
                </Grid>
              </>
            )}
            <Grid item xs={4}>
              <Button variant="outlined" onClick={handleConfirm}>
                ZAPISZ
              </Button>
            </Grid>
          </Grid>
        </Box>
      </StyledModal>
      {editInfoModalOpen && (
        <EditInfoParametersPlants
          open={editInfoModalOpen}
          setOpen={setEditInfoModalOpen}
          selected={props.selected}
          selectionData={props.selectionData}
          currentlySelected={currentlySelected}
          newValues={values}
          editParameter={editParameter}
        />
      )}
      {massEditOpen && (
        <MassEditPlantParametersModal
          local={props.local}
          data={props.data}
          setData={props.setData}
          open={massEditOpen}
          setOpen={setMassEditOpen}
          selected={props.selected}
          updateParameters={props.updateParameters}
        />
      )}
    </>
  );
}
